import { useContext } from 'react';

import { GaugeChartLabelsContext } from '../contexts/GaugeChartLabelsContext.js';

export const useGaugeChartLabelsContext = () =>
  useContext(GaugeChartLabelsContext);
